enum Permission {
  AddCredits = 'add_credits',
  IssueRefund = 'issue_refund',
  ReturnCredits = 'return_credits',
  RemoveCredits = 'remove_credits',
};

export default Permission;
